import React, { useContext, useEffect, useState } from "react";
import QRCode from "react-qr-code";
import qrmobile from "../images/code-mobile.png";
import { SocketContext } from "../component/socket";
import config from "../component/config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import logo from "../images/1_ID.png";
import IOSIcon from "../images/download_iOS.png";
import AndroidIcon from "../images/download_android.png";
import { toast } from "react-toastify";
import { getUserByEmail, liveCheckIdRequest } from "../services/services";
import warning from "../images/warning.png";

function formatLiveStamp(date) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dd = String(date.getDate()).padStart(2, "0");
    const mmm = months[date.getMonth()];
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");
    return `${dd}-${mmm}-${yyyy} ${hh}:${mm}:${ss}`;
}

function getParamFromQueryString(queryString, paramName) {
    const params = queryString.slice(1).split('&');
    for (let i = 0; i < params.length; i++) {
        const [key, value] = params[i].split('=');
        if (key === paramName) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

const CheckMyId = (props) => {
    const [device_id, setDeviceId] = useState(localStorage.getItem("deviceID"));
    const socket = useContext(SocketContext);
    const [isOpenModel, setOpenModel] = useState(false);
    const [isOpenLiveModel, setOpenLiveModel] = useState(false);
    const [messageWarning, setMessageWarning] = useState(false);
    const [liveStamp, setLiveStamp] = useState("");
    const [oneidCardHtml, setOneidCardHtml] = useState("");
    const [requesterEmail, setRequesterEmail] = useState("");

    const [uParam] = useState(props.match.params.email);

    useEffect(async () => {
        var formData = new FormData();
        formData.append("email", uParam);
        let apiResponse = await getUserByEmail(formData);

        if (apiResponse.ResponseCode === 1 || apiResponse.ResponseCode === "1") {
            setuserData(apiResponse.data);
            setOpenModel(true);
        }
        else {
            toast.error(apiResponse.ResponseMsg);
            window.location.href = config.Website;

        }
    }, []);
    const [userData, setuserData] = useState({});

    socket.on("connect", function () {
        setDeviceId(socket.id);
    });

    socket.on("message", async (data) => {
        console.log("scan response--->>>", data);
        if (data && data.ResponseCode && data.ResponseCode == 1) {
            const payload = data.data || {};
            if (payload.device_id == localStorage.getItem("deviceID")) {
                if (payload.msg == "Denied") {
                    setOpenModel(false);
                    setMessageWarning(true);
                }
                else {
                    if (payload.type == "check_my_id") {
                        toast.success(data.ResponseMsg);
                        closeModal();
                    } else if (payload.type == "liveidcheck_contact") {
                        const cardHtml = payload.oneid_card_HTML;
                        setOneidCardHtml(cardHtml == null ? "" : String(cardHtml));
                        setLiveStamp(formatLiveStamp(new Date()));
                        setOpenModel(false);
                        setOpenLiveModel(true);
                    }
                }
            }
        }
        else {
            toast.error(data.ResponseMsg);
        }
    });


    const closeModal = () => {
        window.location.href = ((config.APP_ENV == "live") ? config.Website : config.Website_local);
    };

    const requestVerifiedId = async () => {
        if (!requesterEmail || !requesterEmail.trim()) {
            toast.error("Please enter your email.");
            return;
        }
        if (uParam.toLowerCase() == requesterEmail.toLowerCase()) {
            toast.error("You cannot request verified ID for your own email.");
            return;
        }
        var formData = new FormData();
        formData.append("email", uParam);
        formData.append("requesterEmail", requesterEmail.trim());
        formData.append("deviceId", localStorage.getItem("deviceID"));
        try {
            let apiResponse = await liveCheckIdRequest(formData);
            if (apiResponse.ResponseCode === 1 || apiResponse.ResponseCode === "1") {
                toast.success(apiResponse.ResponseMsg);
            }
            else {
                toast.error(apiResponse.ResponseMsg);
            }
        } catch (error) {
            toast.error("Unable to request verified ID.");
        }
    };

    return (
        <div>
            <Modal
                isOpen={isOpenModel}
                toggle={closeModal}
                className="generate-modal"
            >
                <ModalHeader>
                    <img src={logo} alt="1ID" />
                    <span className="ac-mid-title">Personal 1ID card</span>
                    <span className="ac-sub-title">1:CHECK ID</span>
                </ModalHeader>
                <ModalBody>
                    <div className="generate-div">
                        <h5>Live Verified ID</h5>
                        <p>Should you require live verification of the identity of {userData ? (userData).name + ' ' + (userData).surname : ""}, first insert below your email and then tap button "Request Verified ID</p>
                        {/* here is the input and button*/}
                        <div className="verified-id-request">
                            <input
                                type="email"
                                placeholder="Enter Business Email"
                                value={requesterEmail}
                                onChange={(e) => setRequesterEmail(e.target.value)}
                            />
                            <button type="button" onClick={requestVerifiedId}>
                                Request Verified ID
                            </button>
                        </div>
                        <p>Upon receiving the notification in 1ID App, {userData ? (userData).name + ' ' + (userData).surname : ""} has the option to approve or decline the request for live identity verification.</p>

                        <h5>Exchange ID</h5>
                        <p>
                            You can check the ID of {userData ? (userData).name + ' ' + (userData).surname : ""} by reading the QR code using the scan function located at the bottom navigation of your 1ID App.
                        </p>
                        <p>
                            If you are not an 1ID user already, please download the App "1ID-My Digital Profile" from the Apple App Store /
                            Google Play Store.
                        </p>
                        <div className="qr-div">
                            <img src={qrmobile} alt="" />
                            <QRCode size="200" value={`checkMyId;${device_id};${btoa(JSON.stringify(userData))}`} />
                        </div>
                        <div className="generate-footer">
                            <button
                                type="button"
                                onClick={closeModal}
                                className="margin_0auto"
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="download-free justify-center">
                            <ul className="store_icons">
                                <li>
                                    <a
                                        href={config.APPSTORE}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src={IOSIcon} width="150px" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={config.PLAYSTORE}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src={AndroidIcon} width="150px" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={isOpenLiveModel}
                toggle={closeModal}
                className="generate-modal live-check-modal"
            >
                <ModalHeader>
                    <img src={logo} alt="1ID" />
                    <span className="live-check-time"></span>
                    <span className="ac-sub-title">1:CHECK ID</span>
                </ModalHeader>
                <ModalBody>
                    <h5 className="textcenter">{liveStamp}</h5>
                    <div
                        className="live-id-html"
                        dangerouslySetInnerHTML={{ __html: oneidCardHtml }}
                    />
                    <div className="live-check-close">
                        <button type="button" onClick={closeModal}>
                            Close
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={messageWarning}
                toggle={closeModal}
                className="formmsg-modal"
            >
                <ModalBody>
                    <div className="form-message-body">
                        <img className="warn-img" src={warning} alt="" />
                        <h4>Attention!</h4>
                        <p>
                            Live ID verification was declined.
                        </p>
                    </div>
                    <div className="account-footer">
                        <button type="button" className="btn-darken" onClick={closeModal}>
                            OK
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default CheckMyId;
